/**
 * Apply NHS subset CSS to a Lit render root.
 *
 * Shadow DOM is the default mode. A light-DOM fallback is supported for the
 * small number of cases where document-level styling remains intentional.
 */
const nhsShadowBaseStyles = `
  :host {
    color: inherit;
    font-family: inherit;
  }

  /* Kept out of the accessibility tree entirely; only ever announced via aria-describedby. */
  .aria-describedby-only {
    display: none;
  }
`;

export function applyNhsGlobal<T extends HTMLElement>(
  host: T,
  cssText: string,
  useShadow: boolean = true
): ShadowRoot | T {
  if (!useShadow) {
    return host;
  }

  if (host.shadowRoot) {
    return host.shadowRoot;
  }

  const root = host.attachShadow({ mode: 'open' });

  if (cssText) {
    const styleElement = document.createElement('style');
    styleElement.textContent = `${nhsShadowBaseStyles}${typeof cssText === 'string' ? cssText : ''}`;
    root.appendChild(styleElement);
  }

  return root;
}